import type { Feed } from '@efdigital/ll-addon-data';
import { DataTypeSystem } from '@efdigital/ll-addon-data/data-types';
import { query } from '@warp-drive/utilities/json-api';

import { jsonApiOptions } from '../../../lib/json-api.ts';

export function queryFeeds(clientId: string) {
  return query<Feed>(
    DataTypeSystem.Feed,
    {
      'filter[client.id]': clientId,
    },
    jsonApiOptions
  );
}
